import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

const API_URL = environment.api;

@Injectable()
export class DashboadService {
    constructor (public http: HttpClient, private _authService: AuthService) {}

    private get _headers(): HttpHeaders {
        let h = new HttpHeaders();
        h = h.set('Authorization', `bearer ${this._authService.accessToken}`);
        h = h.set('Content-Type', 'application/json');
        return h;
    }

    changes: Subject<any> = new BehaviorSubject(null);

    adminMessage(): Observable<any> {
        return of({
            title: 'ISSUE ONBOARDING LOANS',
            content: 'There are 23 loans that need attention before they can be imported. Please notify your account administrator.',
            note: 'Note: loans that have not been corrected may effect reports'
        });
    }

    totalLiensTracks(): Observable<any> {
        return of({
            totalTracking: 5500,
            total: 9456681.0,
            data: [
                { 'name': 'Auto', 'value': 2800 },
                { 'name': 'Real Estate', 'value': 1790 },
                { 'name': 'Commercial', 'value': 990 },
                { 'name': 'Flood', 'value': 410 },
                { 'name': 'Equipment', 'value': 1900 }
            ]
        });
    }

    updates(): Observable<any[]> {
        return of([
            {
                title: 'New Team Member',
                description: 'lorum ipsum.',
                postedOn: new Date()
            },
            {
                title: 'New Team Member',
                description: 'lorum ipsum.',
                postedOn: new Date()
            },
        ]);
    }
}
